import React from 'react';

interface RecordDeleteBannerProps {
  isDeleted: boolean;
  showDeletionModal: boolean;
  deletionInfo: {
    deletedAt: Date;
  } | null;
}

const RecordDeleteBanner: React.FC<RecordDeleteBannerProps> = ({
  isDeleted,
  showDeletionModal,
  deletionInfo
}) => {
  if (!isDeleted || showDeletionModal) {
    return null;
  }

  return (
    <div
      className="sky-callout sky-callout-danger"
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 100,
        marginBottom: '15px',
        background: 'var(--red)',
        color: 'white',
        borderLeftColor: 'rgba(255,255,255,0.3)',
      }}
    >
      <strong>This record was deleted</strong>
      {deletionInfo?.deletedAt && ` at ${deletionInfo.deletedAt.toLocaleString()}`}
    </div>
  );
};

export default RecordDeleteBanner;
